

























































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { date } from 'quasar'
import store from 'src/assets/store'
import ItemData from 'src/assets/ItemData'
import { ItemDataUpdate } from 'src/assets/ItemDataLive'
import { AttendeeItemData, AttendeeResponseResult } from 'src/assets/AttendeeItemData'
import PullAndScroll from 'components/PullAndScroll.vue'
import MenuButtonAdd from 'components/presenter/item/session/MenuButtonAdd.vue'
import ListItem from 'components/presenter/item/session/ListItem.vue'
import AttendeesListItem from 'components/presenter/item/session/manager/AttendeesListItem.vue'
import SessionDuration from 'components/presenter/item/session/SessionDuration.vue'
import SessionStatusIcon from 'components/presenter/item/session/SessionStatusIcon.vue'
import api from 'src/assets/api/gql'
import SessionsList from 'src/graphql/session/SessionsList.gql'
import ItemGetData from 'src/graphql/item/ItemGetData.gql'
import TopicSessionAttendees from 'src/graphql/item/TopicSessionAttendees.gql'
import { Item, ItemType, ItemTypeTopic, Session, SessionAttendee } from 'src/graphql/types'

@Component({
  components: {
    MenuButtonAdd,
    ListItem,
    AttendeesListItem,
    SessionDuration,
    SessionStatusIcon
  }
})
export default class PagePresenterSessions extends Vue {
  ItemType = ItemType
  topicData: ItemData | null = null
  loading = true
  tab = ''
  sessions: Session[] = []
  sessionsLoadCursor: string | null = null
  attendees: SessionAttendee[] = []
  attendeesLoadCursor: string | null = null

  @Prop()
  readonly viewport!: PullAndScroll

  get item () {
    return Object.assign({}, store.state.presenter.item, { data: this.topicData || {} })
  }

  @Watch('tab')
  async switchTab() {
    if (!this.topicData) {
      const { data } = await api.query({
        query: ItemGetData,
        variables: {
          id: this.item.id
        }
      })
      this.topicData = new ItemData((data.item?.data || {}) as ItemDataUpdate)
    }
    this.refresh(() => {})
    this.$emit('reload')
  }

  async refresh (done: () => void) {
    this.sessions = []
    this.sessionsLoadCursor = null
    this.attendees = []
    this.attendeesLoadCursor = null
    done()
  }

  async load (index: number, done: (stop?: boolean) => void) {
    this.loading = true
    if (this.tab === '') {
      await this.loadSessions(index, done)
    } else {
      await this.loadAttendees(index, done)
    }
    this.loading = false
  }

  async loadSessions (index: number, done: (stop?: boolean) => void) {
    const { data: { sessions } } = await api.query({
      query: SessionsList,
      variables: {
        topicId: this.item.id,
        after: this.sessionsLoadCursor
      }
    })
    if (sessions) {
      this.sessions.push(...sessions.nodes as Session[])
      this.sessionsLoadCursor = sessions.pageInfo.hasNextPage ? sessions.pageInfo.endCursor : null
      done(!this.sessionsLoadCursor)
    } else {
      done(true)
    }
  }

  async loadAttendees (index: number, done: (stop?: boolean) => void) {
    const { data: { sessionAttendeesByTopicId } } = await api.query({
      query: TopicSessionAttendees,
      variables: {
        topicId: this.item.id,
        after: this.attendeesLoadCursor
      }
    })
    if (sessionAttendeesByTopicId) {
      for (const attendee of sessionAttendeesByTopicId.nodes as SessionAttendee[]) {
        const attendeeItemData = new AttendeeItemData(this.item.typeTopic as ItemTypeTopic, this.topicData as ItemData, attendee)
        const responseResult = new AttendeeResponseResult(attendeeItemData)
        Object.assign(attendee.data, { responseResult })
        this.attendees.push(attendee)
      }
      this.attendeesLoadCursor = sessionAttendeesByTopicId.pageInfo.hasNextPage ? sessionAttendeesByTopicId.pageInfo.endCursor : null
      done(!this.attendeesLoadCursor)
    } else {
      done(true)
    }
  }

  attendeeFormatDate (attendee: SessionAttendee) {
    const datetime = attendee.startedAt || (attendee.session?.startedAt && attendee.session.startedAt > attendee.createdAt ? attendee.session.startedAt : attendee.createdAt)
    return date.formatDate(datetime, 'D MMM \'YY, HH:mm')
  }

  // async loadAttendeesAll () {
  //
  // }
}
